import { useEffect, useRef } from 'react';
/**
 * A hook to replace ye olde `this._isMounted`. Check this value before setting state after a
 * timeout, if it isn't practical to clear that timeout on unmount.
 *
 * @returns A ref with the value `true` if this component is mounted, `false` otherwise
 */

export default function () {
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return mounted;
}